import { render, staticRenderFns } from "./addResponseType.vue?vue&type=template&id=3d9af547"
import script from "./addResponseType.vue?vue&type=script&lang=js"
export * from "./addResponseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports